import React, { useEffect, useRef } from "react";
import { Box, Typography} from "@mui/material";
import Header from "./Header";
import { useAuth } from "../AuthContext";
import { useLoginModal } from "./LoginModalController";

export default function PageGuard({ title, subtitle, children }) {
  const auth = useAuth();
  const { openLogin, loginOpen } = useLoginModal();
  const prompted = useRef(false);

  useEffect(() => {
    if (!auth.isInitialized) return;
    if (!auth.isAuthenticated && !prompted.current && !loginOpen) {
      prompted.current = true;
      openLogin();
    }
  }, [auth.isInitialized, auth.isAuthenticated, openLogin, loginOpen]);

  if (!auth.isInitialized) {
    return (
      <Box p={3}>
        <Typography>Cargando sesión…</Typography>
      </Box>
    );
  }

  return (
    <Box m="20px" ml="5px" sx={{ minHeight: "100vh" }} pb="100px">

      <Header auth={auth} title={title} subtitle={subtitle} />


      {auth.isAuthenticated ? (
        children
      ) : (
[]
      )}
    </Box>
  );
}
